// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
import { MenuList, MenuItem, ListItemIcon, Menu, Stack, Divider, Icon } from 'ui-components';
// App
import styles from './account.module.scss';
import { AccountMenuProps } from './account-menu-props.interface';
import { UnstyledLink } from '@/components/navigation';
import { SHOP_ADMIN_ACCOUNT_PAGES_URLS } from '@/fragments/shop-administration/account/account.constants';
import { SHOP_ADMIN_PAGES_URLS } from '@/fragments/shop-administration/shop-administration.constants';
import { useAccountMenu } from './account-menu.hook';
import AccountMenuUserInfo from './account-menu-user-info';
import CashJournalMenuItem from './cash-journal-menu-item';
import ShopSwitchSearch from '@/fragments/shop-administration/shop/switch';

const ACCOUNT_PERSONAL_DATA = `${SHOP_ADMIN_ACCOUNT_PAGES_URLS['personal-data']}?callback_page=${SHOP_ADMIN_PAGES_URLS['shop-details']}`;

const ACCOUNT_PASSWORD = SHOP_ADMIN_ACCOUNT_PAGES_URLS['password'];

const AccountMenu = (props: AccountMenuProps): ReactElement => {
  const { className, user, ...rest } = props;
  const { stripeSubscriptionId, shopId } = user || {};
  const { createBillingPortalSession, signOut, isSelected, isUserGlobalAdmin } = useAccountMenu();

  const circleeInvoicesUrl = `${SHOP_ADMIN_PAGES_URLS['invoices']}?shp_id=${shopId}`;

  return (
    <Menu className={clsx(className)} {...rest}>
      <MenuList dense>
        <AccountMenuUserInfo user={user} />
        <Stack my={2} px={3}>
          <Divider />
        </Stack>
        <Stack spacing={0.5}>
          {isUserGlobalAdmin && shopId && <ShopSwitchSearch shopId={shopId} />}
          {shopId && (
            <UnstyledLink href={circleeInvoicesUrl}>
              <MenuItem className={styles.menuItem} selected={isSelected(SHOP_ADMIN_PAGES_URLS['invoices'])}>
                <ListItemIcon>
                  <Icon name="invoice" />
                </ListItemIcon>
                Factures Circlee
              </MenuItem>
            </UnstyledLink>
          )}
          {isUserGlobalAdmin && shopId && (
            <CashJournalMenuItem shopId={shopId} selected={isSelected(SHOP_ADMIN_PAGES_URLS['cash-journal'])} />
          )}
          {stripeSubscriptionId && (
            <MenuItem className={styles.menuItem} selected={false} onClick={createBillingPortalSession}>
              <ListItemIcon>
                <Icon name="invoice" />
              </ListItemIcon>
              Factures d&apos;abonnement
            </MenuItem>
          )}
          <UnstyledLink href={ACCOUNT_PERSONAL_DATA}>
            <MenuItem className={styles.menuItem} selected={isSelected(ACCOUNT_PERSONAL_DATA)}>
              <ListItemIcon>
                <Icon name="user" />
              </ListItemIcon>
              Infos personnelles
            </MenuItem>
          </UnstyledLink>
          <UnstyledLink href={ACCOUNT_PASSWORD}>
            <MenuItem className={styles.menuItem} selected={isSelected(ACCOUNT_PASSWORD)}>
              <ListItemIcon>
                <Icon name="key" />
              </ListItemIcon>
              Changer de mot de passe
            </MenuItem>
          </UnstyledLink>
          <div>
            <MenuItem className={styles.menuItem} selected={false} onClick={signOut}>
              <ListItemIcon>
                <Icon name="power-button" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </div>
        </Stack>
      </MenuList>
    </Menu>
  );
};

export default AccountMenu;
